"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormReadonlyField = void 0;
const readonly_field_1 = require("../../../components/readonly-field/readonly-field");
const form_field_1 = require("./form-field");
exports.FormReadonlyField = (0, form_field_1.formFieldFactory)(readonly_field_1.ReadonlyField);
//# sourceMappingURL=form-readonly-field.js.map